<template>
  <div class="heartRate">
    <div class="back" @click="$router.go(-1)">
      <i class="el-icon-back"></i> <span>返回上一页</span>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="心率" name="first">
        <el-radio-group
          v-model="series"
          @change="changeRadiofn"
          style="margin-bottom: 30px"
        >
          <el-radio-button  label="0">单次心率</el-radio-button>
          <el-radio-button label="1">持续心率</el-radio-button>
        </el-radio-group>
        <el-table :data="tableData" :border="true">
          <el-table-column
            label="序号"
            width="80"
            align="center"
            type="index"
            prop=""
          >
          </el-table-column>
          <el-table-column label="测量时间" align="center" prop="DayTimestamp">
            <template slot-scope="scope" align="center">
              {{ scope.row.DayTimestamp  | handtime }}
            </template>
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="DeviceType">
            <template slot-scope="scope" align="center">
              {{ scope.row.DeviceType  || "-"}}
            </template>
          </el-table-column>
          <el-table-column label="心率" align="center" prop="Rate">
            <template slot-scope="scope" align="center">
              {{ scope.row.Rate  || "-"}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="->,total,prev, pager, next"
          :total="total"
          :current-page="page"
          :page-size="size"
          @current-change="changefn"

        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {requestUserHrData} from "@/api/userApi"
import {handtime } from "@/utils/util"
export default {
  name: "heartRate",
  data() {
    return {
      activeName: "first",
      series: 0,
      size:10,
      page:1,
      total:0,
      tableData: [
        {
          date: 111,
        },
      ],
    };
  },
  created (){
    this.requestUserBpDatafn()

  },
  filters:{
    handtime,

  },
  methods: {
    changefn(index){
      this.page =index;
      this.requestUserBpDatafn();
      

    },
    changeRadiofn(index) {
      this.series=index;
      this.requestUserBpDatafn();

      
    },
    async requestUserBpDatafn(){
      try{
      var res =await requestUserHrData({
        userId:this.$route.query.id,
        page:this.page,
        size:this.size,
        series:this.series
      })
      this.tableData=res.data.data.result.list
      this.total=res.data.data.result.count;
      }catch(err){
        console.log(err);
      }
    }
  },
};
</script>

<style lang="less">
.heartRate {
  padding: 15px;
  position: relative;
  .back {
    position: absolute;
    right: 40px;
    top: 15px;
    height: 40px;
    line-height: 40px;
    color: #4276ff;
    z-index: 999;
    cursor: pointer;
  }
  .el-table {
    margin-bottom: 20px;
  }
  thead tr .el-table__cell {
    background-color: #e3e3e3;
    color: #333;
  }
}
</style>